import React from 'react'
import { twMerge } from 'tailwind-merge'
import { TWrapperComponent } from '../../types'

const H3 = ({children, className}: TWrapperComponent) => {
    return (
        <h3 className={twMerge('font-manrope font-extrabold text-2xl text-white leading-3 py-[7px] xl:text-3xl xl:leading-[30px] xl:py-[9px]', className)}>
            {children}
        </h3>
    )
} 

export default H3